// extracted by mini-css-extract-plugin
export var addButton = "_n3-0";
export var border = "_n3-8";
export var check = "_n3-h";
export var danger = "_n3-6";
export var dropdownContainer = "_n3-1";
export var editModalBody = "_n3-j";
export var footerContainer = "_n3-i";
export var fullWidth = "_n3-a";
export var hide = "_n3-9";
export var icon = "_n3-3";
export var input = "_n3-7";
export var inputFlex = "_n3-b";
export var inputWrapper = "_n3-c";
export var manualFocus = "_n3-5";
export var optionButton = "_n3-4";
export var pillWrapper = "_n3-e";
export var pointer = "_n3-2";
export var showOverflow = "_n3-f";
export var tagsFlex = "_n3-d";
export var xButton = "_n3-g";